import { jsx as _jsx } from "react/jsx-runtime";
export const SvgArrowLeft = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm9 7-5 5 5 5m-5-5h16' }) }));
//# sourceMappingURL=arrow-left.js.map